import { useContext } from "react";

import { IamAuthContext } from "@megaron/auth-react";
import {
  canEditSupportTicket,
  hasSupportTicketEditBypassRole,
  type TicketStatus,
} from "@megaron/support-contracts";

export function isSupportTicketEditable(status: TicketStatus, roles: readonly string[] | undefined): boolean {
  return canEditSupportTicket(status, hasSupportTicketEditBypassRole(roles));
}

export function useSupportTicketEditable(status: TicketStatus): boolean {
  const auth = useContext(IamAuthContext);
  const user = auth.iamUser?.userType === "megarax" ? auth.iamUser : undefined;
  return isSupportTicketEditable(status, user?.roles);
}
